import { Box } from 'ui/components/Box'
import { makeComponent } from 'ui/helpers/recipes'

import { DividerStyles, SeparatorStyles } from './Divider.css'

export const Root = makeComponent(Box, DividerStyles)
export const Separator = makeComponent(Box, SeparatorStyles)
